<template>
    <a-card :bordered="false">
      <a-form-item><a @click="routeBack">&lt;&lt; 返回</a></a-form-item>
      <detail-list title="地磅日志详情" v-if="mdl">
        <detail-list-item term="物流单号">{{ mdl.logisticsNo }}</detail-list-item>
        <detail-list-item term="称重单号">{{ mdl.weighingNo }}</detail-list-item>
        <detail-list-item term="车号">{{mdl.vehicleNo }}</detail-list-item>
        <detail-list-item term="秤台名称">{{ mdl.scaleName }}</detail-list-item>
        <detail-list-item term="备注">{{ mdl.remark }}</detail-list-item>
        <detail-list-item term="重量">{{ mdl.weighing }}</detail-list-item>
        <detail-list-item term="最大重量">{{ mdl.maxWeight }}</detail-list-item>
        <detail-list-item term="初稳">{{mdl.firstStopWeight}}</detail-list-item>
        <detail-list-item term="终稳">{{mdl.stopWgtEnd}}</detail-list-item>
        <detail-list-item term="最大稳定">{{mdl.stopWgtMax}}</detail-list-item>
        <detail-list-item term="在秤时间">{{mdl.onTime}}</detail-list-item>
        <detail-list-item term="称重标志">{{mdl.saved}}</detail-list-item>
        <detail-list-item term="时间">{{mdl.createTime | formatDate}}</detail-list-item>
      </detail-list>
    </a-card>
  </page-view>
</template>

<script>
import DetailList from '@/components/tools/DetailList'
import Moment from 'moment'
import storage from "@/utils/storage"


const DetailListItem = DetailList.Item

export default {
  components: {
    DetailList,
    DetailListItem
  },
  data () {
    return {
      mdl: null
    }
  },
  mounted () {
    this.initData()
  },
  filters: {
    formatDate (value) {
      return Moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    routeBack(){
      localStorage.setItem('goback', "true");
      this.$router.back(-1)
    },
    initData () {
      let cache = storage.fetch("cache-WeighingLogDetail")
      if (cache){
          this.mdl = JSON.parse(cache);
      } 
    }
  }
}
</script>



